import { configureStore } from '@reduxjs/toolkit'
import userSlice from "../slices/user-slice.js";
import layoutSlice from "../slices/layout-slice.js";

export const store = configureStore({
    reducer: {
        user: userSlice,
        layout: layoutSlice,
    },
})
